import { BackdropBrowser, SectionTitle } from '@sloyd/ui';
import { Wrapper } from './ContentBackdrops.style';

export type ContentBackdropsProps = {
  backdrops: IBackdrop[];
  isLoading: boolean;
  callbacks: {
    onClick: (item: IBackdrop) => void;
    onAction: OnAction;
  };
};

export function ContentBackdrops(props: ContentBackdropsProps) {
  const { backdrops, callbacks, isLoading } = props;

  const description = `${backdrops.length} items`;

  return (
    <Wrapper className='ContentBackdrops-wrapper' data-testid='ContentBackdrops-wrapper'>
      <BackdropBrowser backdrops={backdrops} isLoading={isLoading} onAction={callbacks.onAction}>
        <SectionTitle
          gradient={{ from: '#fc4a1a', to: '#f7b733' }}
          title='🎨 Backdrops'
          description={description}
          compact
        />
      </BackdropBrowser>
    </Wrapper>
  );
}

export default ContentBackdrops;
